module.exports = __webpack_public_path__ + "static/fonts/BMHANNA_11yrs.4b50cae.woff";